import getCardTemplateStoreDefaultState from './cardTemplateStore/cardTemplateDefaultState'
import cardTemplateActions from './cardTemplateStore/cardTemplateActions'
import cardTemplateMutations from './cardTemplateStore/cardTemplateMutations'

let state = getCardTemplateStoreDefaultState()

export let cardTemplateStore = {
  namespaced: true,
  state,
  mutations: cardTemplateMutations,
  actions: cardTemplateActions
}
